import React from "react";
import Marquee from "react-fast-marquee";
import "./Testimonial.css";

const logos = [
  "/Assets/Images/Service/Services/Testimonial/Testimonial_1.png",
  "/Assets/Images/Service/Services/Testimonial/Testimonial_2.png",
  "/Assets/Images/Service/Services/Testimonial/Testimonial_3.png",
  "/Assets/Images/Service/Services/Testimonial/Testimonial_4.png",
  "/Assets/Images/Service/Services/Testimonial/Testimonial_5.png",
  "/Assets/Images/Service/Services/Testimonial/Testimonial_6.png",

  "/Assets/Images/Service/Services/Testimonial/Testimonial_1.png",
  "/Assets/Images/Service/Services/Testimonial/Testimonial_2.png",
  "/Assets/Images/Service/Services/Testimonial/Testimonial_3.png",
  "/Assets/Images/Service/Services/Testimonial/Testimonial_4.png",
  "/Assets/Images/Service/Services/Testimonial/Testimonial_5.png",
  "/Assets/Images/Service/Services/Testimonial/Testimonial_6.png",

  "/Assets/Images/Service/Services/Testimonial/Testimonial_1.png",
  "/Assets/Images/Service/Services/Testimonial/Testimonial_2.png",
  "/Assets/Images/Service/Services/Testimonial/Testimonial_3.png",
  "/Assets/Images/Service/Services/Testimonial/Testimonial_4.png",
  "/Assets/Images/Service/Services/Testimonial/Testimonial_5.png",
  "/Assets/Images/Service/Services/Testimonial/Testimonial_6.png",
];

function Testimonial() {
  return (
    <section className="Testimonial">
      <div className="heading_holder mb-5">
        <h1 className="heading text-center">Testimonial</h1>
      </div>
      <Marquee pauseOnHover speed={50} loop={0}>
        {logos.map((logo, index) => (
          <div key={index} className="logo_container">
            <img
              src={process.env.PUBLIC_URL + logo}
              alt={`Logo ${index + 1}`}
              className="Testimonial_logo"
            />
          </div>
        ))}
      </Marquee>
    </section>
  );
}

export default Testimonial;
